/**
 * List component for transactions, managing list content and implementing event handler
 * 
 * Properties:
 * 
 *      wallets:    array, array of objects containing wallet transactions
 *      dispatch:   function, common dispatch function
 */

import React, { useState, useEffect} from "react";
import { FormatHelper, Biscuit } from "../../../../utils";
import Popup from "../../../components/Popup";
import t from "../../../helpers/t";
import {useSelector} from 'inbooma-api';
import CheckOutView from "./CheckOutView";
import { rbac } from '../index';
import OrderItem from './OrderItem';
import {getDocHandler} from "../../../../utils/Helper";
import ShowTrackingsDialog from "../../facilities/components/ShowTrackingsDialog";
import LogDialog from "./logs/LogDialog";

 const OrdersList = (props) => {
    const currentUrl = new URL(window.location.href);
    let language = Biscuit.get('user.lang').replace('-','_');

    const _locations = useSelector(state => state.locations_data.locations);
    const [locations,setLocations] = useState(props.locations);
    const [locationsPending,setLocationsPending] = useState(false);

    const [checkoutReservation,setCheckoutReservation] = useState(null);
     const [checkoutCheckin,setCheckoutCheckin] = useState(null);
     const [tempOrder, setTempOrder] = useState(null);
     const [showLogDialog,setShowLogDialog] = useState(false);

    const [popup,setPopup] = useState({
        open: false,
        linkText: "",
        link: ""
    });

     useEffect(() => {

         if (_locations.success === "") return;

         if (_locations.success === true && _locations.data.length) {
             let ld = [];
             _locations.data.map(l => {
                 ld[l.id] = l;
             })
             setLocations(ld);
         } else if (_locations.success === false) {
             console.log("Failed to request locations!");
         }
         setLocationsPending(false);
         //if(!orderPending) {
         //}
     },[_locations]);



    const popupCloseHandler = () => {

        setPopup({
            ...popup,
            open: false
        });
    };

    const getICS = (order) => {
        const body = {
            order_id: order.id,
            client_id: order.client_id
        };
        //getDocHandler("/ics/createICS",'POST','ics',t('order', null, 'capital') + "_" + order.order_nbr + '.ics','',order.id,body);
    }
     const showLog = (order) => {
         setTempOrder(order);
         setShowLogDialog(true);
     }
     const handleCloseDialog = () => {
         setShowLogDialog(false);
         setTempOrder(null);;
     }
    return (
        <div className='inb-c-listing off-canvas-content' id="inb-c-main-orders" style={{ minHeight: "550px" }}>
        {!props.checkout && !locationsPending && props.orders.map((order, index) => {
            let orderMenu =rbac.hasPermission('edit')?
                [
                    {
                        text: t('edit_${a}', {a: t('order', null, 'capital')}),
                        href: "/orders/" + order.id + "/edit" + currentUrl.search,
                        iconClass: "fi fi-wrench",
                        title: "edit"
                    },
                    {
                        text: t('add_payment', null, 'capital'),
                        href: "/orders/" + order.id + "/addpaymentfromorders" + currentUrl.search,
                        iconClass: "fi fi-dollar",
                        title: "payments"
                    },
                    {
                        text: t('create_ics', null, 'capital'),
                        href: "#",
                        clickHandler: getICS,
                        getItem: 'order',
                        order: order,
                        iconClass: "fi fi-calendar",
                        title: "ics"
                    },
                    /*{
                        text: t('show log', null, 'capital'),
                        href: "#",
                        clickHandler: showLog,
                        getItem: 'order',
                        order: order,
                        iconClass: "fi fi-wrench",
                        title: "log"
                    }*/
                ]
                :[];
          /*  if(Biscuit.get('user.is_superuser')  === 'true'){
                orderMenu.push({
                    text: t('changelog', null, 'capital'),
                    href: "#",
                    clickHandler: props.openChangeLog,
                    getItem: 'changeLog',
                    changeLog: order.changeLogs,
                    iconClass: "fi fi-wrench",
                    title: "changelog"
                });
            }*/
                return (
                    <>
                        <OrderItem
                            order={order}
                            index={index}
                            dispatch={props.dispatch}
                            searchParams={currentUrl.searchParams}
                            _exchangeLabel={props._exchangeLabel}
                            setCheckout={props.setCheckout}
                            checkout={props.checkout}
                            setCheckoutCheckin={setCheckoutCheckin}
                            setCheckoutReservation={setCheckoutReservation}
                            setFilter={props.setFilter}
                            filter={props.filter}
                            setNKey={props.setNKey}
                            sort={props.sort}
                            setSort={props.setSort}
                            _key={props._key}
                            locations={locations}
                            orderMenu={orderMenu}
                            setPopup={setPopup}
                            popup={popup}
                            filterChangedHandle={props.filterChangedHandle}
                            showNotification={props.showNotification}
                            />
                       {/* {showLogDialog && <LogDialog
                            handleCloseDialog={handleCloseDialog}
                            order={tempOrder}
                            dispatch={props.dispatch}
                        />}*/}
                    </>
                )
        })
        }

            {props.checkout && checkoutReservation !== null && <CheckOutView
                reservation={checkoutReservation}
                checkin={checkoutCheckin}
                dispatch={props.dispatch}
                filter={props.filter}
                filterChangedHandle={props.filterChangedHandle}
                setCheckout={props.setCheckout}
                _key={props._key}
                setNKey={props.setNKey}
                setFilter={props.setFilter}
                sort={props.sort}
                setSort={props.setSort}
            />}
        {popup.open === true &&
            <Popup
                left={popup.left}
                top={popup.top}
                linkText={popup.linkText}
                text={popup.text}
                link={popup.link}
                onCloseHandler={popupCloseHandler}/>
        }
        </div>
    );
 };
 export default OrdersList;